import { render, staticRenderFns } from "./PregledSteta.vue?vue&type=template&id=33d51de6&scoped=true&"
import script from "./PregledSteta.vue?vue&type=script&lang=ts&"
export * from "./PregledSteta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d51de6",
  null
  
)

export default component.exports